import React from "react";

const baseStrokeProps = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const ConnectIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <line x1="20" y1="8" x2="20" y2="14" />
    <line x1="23" y1="11" x2="17" y2="11" />
  </svg>
);

export const MessageIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} {...props}>
    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
  </svg>
);

export const FollowIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="m17 11 2 2 4-5" />
  </svg>
);

export const RemoveIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} {...props}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <line x1="17" y1="8" x2="22" y2="13" />
    <line x1="22" y1="8" x2="17" y2="13" />
  </svg>
);

export const AcceptIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} strokeWidth={2.4} {...props}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const CrossIcon = (props) => (
  <svg viewBox="0 0 24 24" {...baseStrokeProps} strokeWidth={2.4} {...props}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const KEY_ICON_MAP = {
  connect: ConnectIcon,
  follow: FollowIcon,
  following: FollowIcon,
  message: MessageIcon,
  remove: RemoveIcon,
  accept: AcceptIcon,
  reject: CrossIcon,
  cancel: CrossIcon,
};

const VARIANT_FALLBACK_MAP = {
  primary: ConnectIcon,
  default: ConnectIcon,
  success: AcceptIcon,
  danger: CrossIcon,
  secondary: MessageIcon,
};

const ACTION_KEY_SEPARATOR_PATTERN = "[-_:.]";

const hasActionKeySegment = (key, actionName) => {
  if (!key) {
    return false;
  }

  return new RegExp(`(^|${ACTION_KEY_SEPARATOR_PATTERN})${actionName}($|${ACTION_KEY_SEPARATOR_PATTERN})`).test(key);
};

/**
 * Pick the inline-SVG icon component for a friendship action. Semantic key
 * segments (connect / message / remove / accept / reject / cancel) take
 * priority; if none matches we fall back to a sensible default derived from
 * the variant.
 */
export const pickFriendshipActionIcon = (action) => {
  if (!action) return MessageIcon;
  const key = typeof action.key === "string" ? action.key.toLowerCase() : "";
  const matchedKey = Object.keys(KEY_ICON_MAP).find((actionName) => hasActionKeySegment(key, actionName));
  if (matchedKey) return KEY_ICON_MAP[matchedKey];
  return VARIANT_FALLBACK_MAP[action.variant] || MessageIcon;
};
